import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import PrevCalifications from '../PrevCalifications/PrevCalifications';
import classes from './QuizInstructions.module.css';

const QuizInstructions = props => {
  const { t } = useTranslation(['lesson']);
  const [calificationsView, setCalificationsView] = useState(false);

  const chanveViewHandler = () => {
    setCalificationsView(!calificationsView);
  };

  return (
    <>
      <div className={classes.quizContainer}>
        <aside className={classes.instructionsContainer}>
          {!calificationsView ? (
            <>
              <p className={classes.instructions__title}>
                {t('instructions')}:
              </p>
              <p className={classes.instructions__text}>
                {props.description}
              </p>
            </>
          ) : (
            <PrevCalifications
              califications={props.preCalifications}
            />
          )}
        </aside>
      </div>
      <aside className={classes.btnsContainer}>
        {props.preCalifications && (
          <Button
            onClick={chanveViewHandler}
            className={classes.nextBtn}
          >
            {!calificationsView ? (
              <>
                {t('view_ratings')} <AssignmentIcon />
              </>
            ) : (
              <>
                <ChevronLeftIcon /> {t('back')}
              </>
            )}
          </Button>
        )}
        {!calificationsView && (
          <Button
            onClick={props.changeView}
            className={classes.nextBtn}
          >
            {t('next')} <ChevronRightIcon />
          </Button>
        )}
      </aside>
    </>
  );
};

QuizInstructions.propTypes = {
  // eslint-disable-next-line react/require-default-props
  description: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  idCourse: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  preCalifications: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  changeView: PropTypes.func
};

export default QuizInstructions;
